{
  "version": "v4.2.5",
  "name": "TestDynamicSortedArrayForU256",
  "bytecode": "0008402d4056408840a640f341234141414f010002040115d3cee93194160116000006311342277b160113202c170216001602160213202a62170316037102010002030114d33cd5e72916004313202e0c2f1342267b16004313202d1702160016010c1602000402010002030119d32cabd28216004313202e0c2f1342267b160016010001170216020b244c031600024a05160016023d00050201000202010ed31bc25d3416004313202e0c2f1342267b160016016b44020000040601402a16021603344c020b02160216032a0e2d17041600160400001705160516012f4c0316043f0216051601314c091600160116040d2a16030004024a061600160116021604000402010002030118d34b2e25b7160116000006311342277b160113202c170216000c1602621600160213202a16004362440201000101010ed30041471116004313202e0c2f1342267b16004313202d02010000000103d3676c3c33140002",
  "codeHash": "86f2584a16af632c63b6c1ead625d4d53f11b9a3f2d465010085bd740be281d3",
  "fieldsSig": {
    "names": [],
    "types": [],
    "isMutable": []
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "get",
      "paramNames": [
        "array",
        "index"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "find",
      "paramNames": [
        "array",
        "value"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "I256"
      ]
    },
    {
      "name": "remove",
      "paramNames": [
        "array",
        "value"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "push",
      "paramNames": [
        "array",
        "value"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "binarySearch",
      "paramNames": [
        "array",
        "value",
        "left",
        "right"
      ],
      "paramTypes": [
        "ByteVec",
        "U256",
        "U256",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false,
        false
      ],
      "returnTypes": [
        "I256"
      ]
    },
    {
      "name": "removeAt",
      "paramNames": [
        "array",
        "index"
      ],
      "paramTypes": [
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false
      ],
      "returnTypes": [
        "ByteVec"
      ]
    },
    {
      "name": "size",
      "paramNames": [
        "array"
      ],
      "paramTypes": [
        "ByteVec"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "U256"
      ]
    },
    {
      "name": "empty",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": [
        "ByteVec"
      ]
    }
  ],
  "constants": [
    {
      "name": "IntByteLength",
      "value": {
        "type": "U256",
        "value": "32"
      }
    }
  ],
  "enums": [
    {
      "name": "ErrorCode",
      "fields": [
        {
          "name": "InvalidArrayLength",
          "value": {
            "type": "U256",
            "value": "550"
          }
        },
        {
          "name": "IndexOutOfBound",
          "value": {
            "type": "U256",
            "value": "551"
          }
        },
        {
          "name": "InvalidByteVecLength",
          "value": {
            "type": "U256",
            "value": "552"
          }
        }
      ]
    }
  ]
}